module.exports = __webpack_public_path__ + "img/depressie_examen_gezakt.png";